export const isNullOrUndefined = (value: unknown): value is null | undefined =>
  // here check the double equal sign `==` instead of `===`
  // because `undefined == null` is true
  value == null;
